import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import { EmployeeTrial } from './EmployeeTrial';

export const EmployeeListTrial = ({ employees, onEmployeeSelect, onPerkCardSelect, cardCount, onExpenseCardSelect, onAllEmployeesToggle, setSelectedTeamClick, allEmployeesSelected, setSelectedEmployee, setClickEmployeeName, handleSeeEmployeeDetails, maxCards }) => {
    // const selectedEmployees = employees.filter(employee => {return employee.role === 'employee'})
    return (
        <table className="teams-table" style={{ width: '100%', backgroundColor: 'transparent', textAlign: 'center', marginTop: 5, paddingLeft: 5, paddingRight: 5 }}>
            <thead>
                <tr className="table-row" style={{ fontStyle: 'SFProText-Medium', fontSize: 14, fontWeight: '900' }}>
                    <th><Checkbox checked={allEmployeesSelected} onChange={onAllEmployeesToggle} disabled={cardCount === 0} /></th>
                    <th>Employee Name</th>
                    <th>Team Name</th>
                    <th>Work Email</th>
                    <th>Perk Card</th>
                    <th>Expense Card</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {employees.map(employee => <EmployeeTrial key={employee.id} employee={employee} 
                        setSelectedTeamClick={setSelectedTeamClick} cardCount={cardCount} 
                        setClickEmployeeName={setClickEmployeeName} onEmployeeSelect={onEmployeeSelect} 
                        onPerkCardSelect={onPerkCardSelect} onExpenseCardSelect={onExpenseCardSelect} 
                        setSelectedEmployee={setSelectedEmployee} handleSeeEmployeeDetails={handleSeeEmployeeDetails} 
                        maxCards={maxCards} />)}
            </tbody>
        </table>
    );
};
